import { FeatureActionConstants } from "../action-constants/index.js";

const setActiveFeatures = activeFeatures => ({
  type: FeatureActionConstants.SET_ACTIVE_FEATURES,
  payload: activeFeatures
});

const setABTestActiveFeatures = abTestActiveFeatures => ({
  type: FeatureActionConstants.SET_ABTEST_ACTIVE_FEATURES,
  payload: abTestActiveFeatures
});

const setActiveFeatureFlags = activeFeatureFlags => ({
  type: FeatureActionConstants.SET_ACTIVE_FEATURE_FLAGS,
  payload: activeFeatureFlags
});

export default {
  setActiveFeatures,
  setABTestActiveFeatures,
  setActiveFeatureFlags
};
